// 引用AES源码js
import md5 from 'js-md5'
import CryptoJS from 'crypto-js'

// 加密方法
export function Encrypt (word, random) {
  let md5Random = md5(random).substring(8, 24).toUpperCase()
  let key = CryptoJS.enc.Utf8.parse(md5Random.substring(0, 16))
  let iv = CryptoJS.enc.Utf8.parse(md5Random.substring(8, 16) + md5Random.substring(0, 8))
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.ciphertext.toString()
}

// 根据 aes 密钥动态加密
export function encryptWithAES (aesKey, text, iv_base64) {
  const key = CryptoJS.enc.Base64.parse(aesKey);
  const iv = CryptoJS.enc.Base64.parse(iv_base64);
  
  // 这里是加密的核心方法
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv,
    mode: CryptoJS.mode.CBC, // 使用 CBC 模式（也可以根据需求改为 CBC 等其他模式）
    padding: CryptoJS.pad.Pkcs7, // 使用 PKCS7 填充
  });

  return encrypted.toString();
}
